/*@ngInject*/
const ReevaluateSubmissionRepository = function (baseRepository) {

    angular.extend(this, baseRepository);

    this.reevaluate = function (submissionId) {
        var url = '/rest/Submission/' + submissionId + '/reevaluateSubmission',
            config = {
                headers: {
                    'Content-Type': 'application/json'
                }
            };

        return this.post(url, {}, config);
    };
};

angular.module('gw-um-submission').service('reevaluateSubmissionRepository', ReevaluateSubmissionRepository);
